var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiteraU(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Litera_U",
    "data-name": "Litera U",
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 125,
    height: 125,
    rx: 62.5,
    fill: "#eda751"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28652_",
    transform: "translate(19.751 26.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_247_",
    d: "M93.881,221.23,81.433,223.7l-5.43.608-2.568-.588L48.97,210.213v22.74q.265,6.293,10.645,12.291a43.748,43.748,0,0,0,21.76,6.234,40.834,40.834,0,0,0,21.093-5.665l30.581-17.663V205.41Z",
    transform: "translate(-48.276 -179.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_242_",
    transform: "translate(0.354 0.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_245_",
    d: "M133.062,217.712l-30.581,17.662a40.834,40.834,0,0,1-21.093,5.665,43.951,43.951,0,0,1-21.76-6.234c-6.92-4-10.488-8.1-10.645-12.291q-.265-6.293,9.723-12.056L89.6,192.62l13.8,7.959L73.585,217.791c-3.587,2.078-5.528,3.96-5.8,5.685-.274,1.705.882,3.333,3.509,4.842a14.539,14.539,0,0,0,8.508,2.117,23.325,23.325,0,0,0,9.8-3.47l29.758-17.172Z",
    transform: "translate(-48.624 -192.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_243_",
    d: "M132.882,219.532,102.3,237.195a40.833,40.833,0,0,1-21.093,5.665,43.95,43.95,0,0,1-21.76-6.234c-6.92-4-10.488-8.1-10.645-12.291q-.265-6.293,9.723-12.056L89.421,194.44l13.8,7.959L73.405,219.611c-3.587,2.078-5.528,3.96-5.8,5.685-.274,1.705.9,3.333,3.509,4.842a14.708,14.708,0,0,0,8.508,2.137,23.325,23.325,0,0,0,9.8-3.47l29.758-17.172Z",
    transform: "translate(-48.797 -190.872)",
    fill: "#eda751"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_237_",
    d: "M134.114,218.537v-.823l-.647-.372h0l-13.781-7.959-15.251,8.8V200.561l-.529-.314L89.928,192.19,58.68,210.225c-6.861,3.96-10.252,8.233-10.056,12.683a5.585,5.585,0,0,0,.059.568l-.059-.059v22.211c.176,4.43,3.881,8.763,11,12.879a44.626,44.626,0,0,0,22.112,6.332h.372a41.638,41.638,0,0,0,21.073-5.763l30.934-17.859V218.537ZM59.386,211.48l30.542-17.643,12.389,7.155L73.559,217.6c-3.823,2.215-5.822,4.234-6.155,6.175-.333,2.019.961,3.9,3.862,5.567a15.437,15.437,0,0,0,8.919,2.215,24.342,24.342,0,0,0,10.1-3.568l29.4-16.976L132,218.125,102.474,235.18a40.532,40.532,0,0,1-20.74,5.567,43.189,43.189,0,0,1-21.407-6.155c-6.665-3.862-10.135-7.8-10.292-11.7C49.859,218.988,53.015,215.145,59.386,211.48Zm.941,45.852c-6.665-3.862-10.135-7.8-10.292-11.684V227.417c1.686,2.882,4.9,5.685,9.586,8.39a49.163,49.163,0,0,0,6.136,3v21.211A49.8,49.8,0,0,1,60.327,257.332Zm13.879,5.332V241.355a40,40,0,0,0,5.489.686v21.328A37.21,37.21,0,0,1,74.206,262.664Z",
    transform: "translate(-48.616 -192.19)",
    fill: "#0c1859"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3207_",
    transform: "translate(20.185 32.409)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3204_",
    cx: 1.353,
    cy: 0.784,
    rx: 1.353,
    ry: 0.784,
    transform: "translate(34.957 43.166)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3203_",
    d: "M71.516,216.165c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.039,2.039,0,0,1,71.516,216.165Z",
    transform: "translate(-29.266 -175.626)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3199_",
    d: "M74.056,214.7a.578.578,0,0,1,0,1.1,2.039,2.039,0,0,1-1.9,0,.578.578,0,0,1,0-1.1A2.039,2.039,0,0,1,74.056,214.7Z",
    transform: "translate(-26.827 -177.037)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3198_",
    d: "M63.886,217.618a.578.578,0,0,1,0,1.1,2.039,2.039,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.16,2.16,0,0,1,63.886,217.618Z",
    transform: "translate(-36.593 -174.216)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3197_",
    cx: 1.353,
    cy: 0.784,
    rx: 1.353,
    ry: 0.784,
    transform: "translate(29.959 40.304)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3196_",
    cx: 1.353,
    cy: 0.784,
    rx: 1.353,
    ry: 0.784,
    transform: "translate(34.957 37.423)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3195_",
    d: "M71.516,213.225c.529.314.529.8,0,1.1a2.16,2.16,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.039,2.039,0,0,1,71.516,213.225Z",
    transform: "translate(-29.266 -178.449)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3194_",
    d: "M61.336,216.165c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.039,2.039,0,0,1,61.336,216.165Z",
    transform: "translate(-39.042 -175.626)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3193_",
    d: "M63.886,214.7c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.039,2.039,0,0,1,63.886,214.7Z",
    transform: "translate(-36.593 -177.037)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3192_",
    cx: 1.353,
    cy: 0.784,
    rx: 1.353,
    ry: 0.784,
    transform: "translate(15.001 37.423)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3191_",
    d: "M61.336,213.225c.529.314.529.8,0,1.1a2.16,2.16,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.039,2.039,0,0,1,61.336,213.225Z",
    transform: "translate(-39.042 -178.449)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3189_",
    d: "M56.246,213.225c.529.314.529.8,0,1.1a2.16,2.16,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.039,2.039,0,0,1,56.246,213.225Z",
    transform: "translate(-43.93 -178.449)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3188_",
    d: "M58.8,211.755c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0,.578.578,0,0,1,0-1.1A2.039,2.039,0,0,1,58.8,211.755Z",
    transform: "translate(-41.481 -179.861)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3182_",
    d: "M53.706,211.755c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0,.578.578,0,0,1,0-1.1A2.039,2.039,0,0,1,53.706,211.755Z",
    transform: "translate(-46.369 -179.861)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3180_",
    d: "M56.246,210.278c.529.314.529.8,0,1.1a2.16,2.16,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.16,2.16,0,0,1,56.246,210.278Z",
    transform: "translate(-43.93 -181.265)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3179_",
    d: "M58.8,208.808c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.16,2.16,0,0,1,58.8,208.808Z",
    transform: "translate(-41.481 -182.677)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3178_",
    d: "M51.136,210.275c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.039,2.039,0,0,1,51.136,210.275Z",
    transform: "translate(-48.837 -181.282)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3168_",
    cx: 1.353,
    cy: 0.784,
    rx: 1.353,
    ry: 0.784,
    transform: "translate(4.984 25.876)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3167_",
    d: "M56.226,207.335c.529.314.529.8,0,1.1a2.16,2.16,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.039,2.039,0,0,1,56.226,207.335Z",
    transform: "translate(-43.949 -184.105)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3163_",
    d: "M58.776,205.865a.578.578,0,0,1,0,1.1,2.039,2.039,0,0,1-1.9,0,.578.578,0,0,1,0-1.1A2.039,2.039,0,0,1,58.776,205.865Z",
    transform: "translate(-41.501 -185.517)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3161_",
    d: "M51.136,207.335c.529.314.529.8,0,1.1a2.16,2.16,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.039,2.039,0,0,1,51.136,207.335Z",
    transform: "translate(-48.837 -184.105)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3160_",
    d: "M53.686,205.865a.578.578,0,0,1,0,1.1,2.039,2.039,0,0,1-1.9,0,.578.578,0,0,1,0-1.1A2.039,2.039,0,0,1,53.686,205.865Z",
    transform: "translate(-46.389 -185.517)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3157_",
    d: "M56.226,204.388a.578.578,0,0,1,0,1.1,2.039,2.039,0,0,1-1.9,0,.578.578,0,0,1,0-1.1A2.16,2.16,0,0,1,56.226,204.388Z",
    transform: "translate(-43.949 -186.921)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3156_",
    d: "M74.7,213.245a2.039,2.039,0,0,1,1.9,0,.578.578,0,0,1,0,1.1,2.039,2.039,0,0,1-1.9,0A.578.578,0,0,1,74.7,213.245Z",
    transform: "translate(-24.378 -178.43)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3139_",
    d: "M79.156,211.775c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0,.578.578,0,0,1,0-1.1A2.039,2.039,0,0,1,79.156,211.775Z",
    transform: "translate(-21.929 -179.842)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3138_",
    d: "M81.706,210.305c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.039,2.039,0,0,1,81.706,210.305Z",
    transform: "translate(-19.48 -181.253)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3137_",
    d: "M84.246,208.828c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.16,2.16,0,0,1,84.246,208.828Z",
    transform: "translate(-17.041 -182.658)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3136_",
    d: "M86.8,207.358a.578.578,0,0,1,0,1.1,2.16,2.16,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.16,2.16,0,0,1,86.8,207.358Z",
    transform: "translate(-14.592 -184.069)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3135_",
    d: "M89.336,205.888c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.16,2.16,0,0,1,89.336,205.888Z",
    transform: "translate(-12.153 -185.481)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3134_",
    d: "M72.164,211.775a2.039,2.039,0,0,1,1.9,0,.578.578,0,0,1,0,1.1,2.039,2.039,0,0,1-1.9,0C71.635,212.579,71.635,212.089,72.164,211.775Z",
    transform: "translate(-26.817 -179.842)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3133_",
    d: "M76.616,210.305c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.039,2.039,0,0,1,76.616,210.305Z",
    transform: "translate(-24.368 -181.253)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3132_",
    d: "M79.156,208.828c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.16,2.16,0,0,1,79.156,208.828Z",
    transform: "translate(-21.929 -182.658)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3128_",
    d: "M81.706,207.358a.578.578,0,0,1,0,1.1,2.16,2.16,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.16,2.16,0,0,1,81.706,207.358Z",
    transform: "translate(-19.48 -184.069)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3095_",
    d: "M84.246,205.888c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.16,2.16,0,0,1,84.246,205.888Z",
    transform: "translate(-17.041 -185.481)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3094_",
    d: "M86.8,204.435c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.039,2.039,0,0,1,86.8,204.435Z",
    transform: "translate(-14.592 -186.89)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3093_",
    d: "M59.414,204.415a2.039,2.039,0,0,1,1.9,0,.578.578,0,0,1,0,1.1,2.039,2.039,0,0,1-1.9,0C58.885,205.219,58.885,204.729,59.414,204.415Z",
    transform: "translate(-39.061 -186.91)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3091_",
    d: "M63.866,202.938c.529.314.529.8,0,1.1a2.16,2.16,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.16,2.16,0,0,1,63.866,202.938Z",
    transform: "translate(-36.613 -188.314)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3080_",
    d: "M66.416,201.468c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0,.578.578,0,0,1,0-1.1A2.16,2.16,0,0,1,66.416,201.468Z",
    transform: "translate(-34.164 -189.726)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3079_",
    cx: 1.353,
    cy: 0.784,
    rx: 1.353,
    ry: 0.784,
    transform: "translate(34.918 8.645)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3065_",
    d: "M71.506,198.545c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.039,2.039,0,0,1,71.506,198.545Z",
    transform: "translate(-29.276 -192.547)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3063_",
    cx: 1.353,
    cy: 0.784,
    rx: 1.353,
    ry: 0.784,
    transform: "translate(44.896 2.882)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3062_",
    d: "M56.874,202.945a2.039,2.039,0,0,1,1.9,0,.578.578,0,0,1,0,1.1,2.039,2.039,0,0,1-1.9,0C56.345,203.749,56.345,203.259,56.874,202.945Z",
    transform: "translate(-41.501 -188.321)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3061_",
    cx: 1.353,
    cy: 0.784,
    rx: 1.353,
    ry: 0.784,
    transform: "translate(19.961 11.507)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3060_",
    d: "M63.866,200c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.16,2.16,0,0,1,63.866,200Z",
    transform: "translate(-36.613 -191.137)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3059_",
    d: "M66.416,198.545c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.039,2.039,0,0,1,66.416,198.545Z",
    transform: "translate(-34.164 -192.547)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3049_",
    d: "M68.956,197.075a.578.578,0,0,1,0,1.1,2.16,2.16,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.039,2.039,0,0,1,68.956,197.075Z",
    transform: "translate(-31.725 -193.958)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3025_",
    d: "M71.506,195.605c.529.314.529.8,0,1.1a2.039,2.039,0,0,1-1.9,0c-.529-.314-.529-.8,0-1.1A2.039,2.039,0,0,1,71.506,195.605Z",
    transform: "translate(-29.276 -195.37)",
    fill: "#0c1859"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiteraU);
export default __webpack_public_path__ + "static/media/Litera U.000899573ca2a8d8e43b4755f18d02d2.svg";
export { ForwardRef as ReactComponent };